import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { oktaTokenBaseQuery } from "@/react/services/api";
import { HttpMethods } from "@/react/http";

const BASE_URL = Object.freeze("/v1/dialplans");

export const xmlDialplansApi = createApi({
  reducerPath: "xmlDialplansApi",
  baseQuery: oktaTokenBaseQuery(),
  endpoints: (builder) => ({
    convertXmlFileToDialplan: builder.mutation({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("file", file); // 'file' should match backend's expected param name
        return {
          url: `${BASE_URL}/convert_file_to_json`,
          method: HttpMethods.POST,
          body: formData,
        };
      },
    }),
    convertDialplanToXmlFile: builder.mutation({
      query: ({ dialplan }) => ({
        url: `${BASE_URL}/convert_json_to_xml_file`,
        method: HttpMethods.POST,
        body: dialplan,
      }),
    }),
  }),
});

export const {
  useConvertXmlFileToDialplanMutation,
  useConvertDialplanToXmlFileMutation,
} = xmlDialplansApi;
